import * as React from 'react'
import { useEffect, useState } from 'react'
import { Badge, Card, Empty, Spin, Tag, Typography } from 'antd'
import dayjs from 'dayjs'
import { PageProps } from '../'

const API_URL = process.env.REACT_APP_API_URL ?? ''

interface NotificationRecord {
  id: string
  title?: string
  content: string
  date: string
  isRead: boolean
}

const Notifications: React.FC<PageProps> = ({ userName, loginToken }) => {
  const [records, setRecords] = useState<NotificationRecord[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userName) return
    setLoading(true)
    fetch(`${API_URL}/notifications/history/get`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: userName }),
    })
      .then(res => res.json())
      .then(json => setRecords(json.success ?? []))
      .catch(() => setRecords([]))
      .finally(() => setLoading(false))
  }, [userName])

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 64 }}>
        <Spin />
      </div>
    )
  }

  if (records.length === 0) {
    return (
      <div style={{ padding: 48 }}>
        <Empty description='No notifications sent yet.' />
      </div>
    )
  }

  return (
    <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
      {records.map(record => (
        <Card
          key={record.id}
          size='small'
          style={{ borderRadius: 12, borderColor: record.isRead ? '#f0f0f0' : '#d6e4ff' }}
          styles={{ body: { padding: '14px 16px' } }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
            <div style={{ flex: 1 }}>
              {record.title && (
                <Typography.Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>
                  {record.title}
                </Typography.Text>
              )}
              <Typography.Text style={{ fontSize: 14, color: '#595959', display: 'block', marginBottom: 8 }}>
                {record.content}
              </Typography.Text>
              <Typography.Text type='secondary' style={{ fontSize: 12 }}>
                {dayjs(record.date).format('DD MMM YYYY · h:mm A')}
              </Typography.Text>
            </div>
            <div style={{ flexShrink: 0 }}>
              {record.isRead ? (
                <Tag color='success'>Read</Tag>
              ) : (
                <Badge status='processing' text={<span style={{ fontSize: 12, color: '#1677ff' }}>Unread</span>} />
              )}
            </div>
          </div>
        </Card>
      ))}
    </div>
  )
}

export default Notifications
